
import { defineComponent, ref, PropType } from 'vue'
import { useWirepasTopologyGraph } from '@/composables/useWirepasTopologyGraph'
import {
  radiusOf, nodeFill, linkId,
  CANVAS_BG, C_GRID, C_GW, C_ANCHOR, C_ANCHOR_BORDER, C_TEXT, C_DIM, C_EDGE, C_OFF,
} from '@/utils/wirepas-topology'

// This component is intentionally a thin view: all fetching/polling, the d3-force simulation
// engine and the pan/zoom/drag interaction live in composables (useWirepasTopologyGraph /
// useGraphPanZoom) so they're testable and reusable independent of this template.
const __default__ = defineComponent({
  name: 'WirepasTopologyGraph',
  props: {
    // Whether this tab is shown -- gates fetching/polling.
    active: { type: Boolean as PropType<boolean>, default: false },
  },
  setup(props) {
    const panelEl = ref<HTMLDivElement | null>(null)
    const svgEl = ref<SVGSVGElement | null>(null)
    const graph = useWirepasTopologyGraph(props, panelEl, svgEl)
    const departedExpanded = ref(false)
    const overflowExpanded = ref(false)

    return {
      panelEl, svgEl, departedExpanded, overflowExpanded,
      radiusOf, nodeFill, linkId,
      CANVAS_BG, C_GRID, C_GW, C_ANCHOR, C_ANCHOR_BORDER, C_TEXT, C_DIM, C_EDGE, C_OFF,
      ...graph,
    }
  },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "f73387cc": (_ctx.C_GW),
  "v38a6b78c": (_ctx.C_ANCHOR_BORDER),
  "v226be79e": (_ctx.CANVAS_BG),
  "v03c793f0": (_ctx.C_GRID),
  "v08613a7e": (_ctx.C_DIM)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__